import { useTranslate } from "src/i18n";

import { PluralForms } from "../../../../../../utils";

export const useProductInfoTranslate = () => {
  const { t } = useTranslate();

  const deliveryDays: PluralForms = [
    t("product_info.delivery_day_one", "день"),
    t("product_info.delivery_day_few", "дня"),
    t("product_info.delivery_day_many", "дней"),
  ];

  const deliveryHours: PluralForms = [
    t("product_info.delivery_hour_one", "час"),
    t("product_info.delivery_hour_few", "часа"),
    t("product_info.delivery_hour_many", "часов"),
  ];

  return {
    cost: t("product_info.cost", "Цена"),
    delivery: t("product_info.delivery", "Сроки доставки"),
    delivery_days: deliveryDays,
    delivery_hours: deliveryHours,
    open_store: t("product_info.open_store", "Открыть на площадке"),
    select_platform_hint: t(
      "product_info.select_platform_hint",
      "Выберите платформу выше, чтобы загрузить цену",
    ),
  };
};
